// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gray{color:#292727}.login-link-wrapper{display:flex;justify-content:center;align-items:center;padding-bottom:0.7rem}.reset-link{margin:0.5rem 0;text-decoration:underline;padding-left:0.4rem;border:none;background:transparent}.google-login-button-wrapper{margin-bottom:1rem}.apple-login-button-wrapper{margin-bottom:3rem}\n", ""]);
// Exports
module.exports = exports;
